import * as React from "react";
import { Dialog, Grid } from "@mui/material";
import ChartDialogTitle from "./ChartDialogTitle";

export default function ChartDialogContainer({
  handleClose,
  isOpen,
  children,
  isMobile,
  maxWidth: maxWidthProp,
  paperSx,
}) {
  const resolvedMaxWidth = maxWidthProp ?? (isMobile ? false : "xl");

  return (
    <Dialog
      disableEscapeKeyDown={false}
      fullWidth={true}
      maxWidth={resolvedMaxWidth}
      fullScreen={isMobile}
      open={isOpen}
      onClose={handleClose}
      sx={{
        ".MuiDialog-paper": {
          height: isMobile ? "100%" : "96vh",
          maxHeight: isMobile ? "100vh" : "96vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          ...(isMobile
            ? {
                margin: 0,
                borderRadius: 0,
                maxWidth: "100vw",
              }
            : {
                borderRadius: 2,
                boxShadow: "0 8px 40px rgba(15, 23, 42, 0.12)",
              }),
          ...paperSx,
        },
      }}
    >
      <ChartDialogTitle handleClose={handleClose} />
      <Grid
        container
        direction={"row"}
        sx={{
          flex: 1,
          minHeight: 0,
          height: "100%",
          overflow: "hidden",
          alignItems: "stretch",
          "& > .MuiGrid-item": {
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
          },
        }}
      >
        {children}
      </Grid>
    </Dialog>
  );
}
